import { MonthSwitcher as SharedMonthSwitcher } from "@/components/month/MonthSwitcher";
import { browserTimeZone, monthKeyOf, monthStart } from "@/lib/month/month";
import { type IsoDate, todayInZone } from "@/lib/time/dates";

interface MonthSwitcherProps {
  month: IsoDate;
  onChange: (month: IsoDate) => void;
  /** Names a second switcher on the page (see PeriodSwitcher). */
  scope?: string;
}

/** Team pages hold no person-period range: any month can be opened, so the bounds are wide open. */
const FIRST = "1970-01";
const LAST = "2999-12";

/**
 * The My Team month switcher: the shared Home/Guidance switcher (arrows, label, "This month")
 * adapted to the first-of-month dates the team reads use.
 */
export function MonthSwitcher({ month, onChange, scope }: MonthSwitcherProps) {
  const current = monthKeyOf(todayInZone(new Date(), browserTimeZone()));
  return (
    <SharedMonthSwitcher
      month={monthKeyOf(month)}
      current={current}
      min={FIRST}
      max={LAST}
      onChange={(key) => onChange(monthStart(key))}
      scope={scope}
    />
  );
}
